var render, staticRenderFns
import script from "./ExpandTransition.vue?vue&type=script&lang=js"
export * from "./ExpandTransition.vue?vue&type=script&lang=js"
import style0 from "./ExpandTransition.vue?vue&type=style&index=0&id=13b6405a&prod&scoped=true&lang=css"
import style1 from "./ExpandTransition.vue?vue&type=style&index=1&id=13b6405a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b6405a",
  null
  
)

export default component.exports